//Imports node_modules
import React, { useContext } from "react"

//Imports Css
import './ObraCard.css'

//Imports Components

//Import Data
import { globalFunctions } from '../../../data/GlobalFunctions'

//Este Botão foi principlamente feito para evitar duplo click, detetar micro deslizes de dedos, touch and click events
const ObraCard = (params) => {

    //--- Variaveis
    const {
        advancedClick,
    } = useContext(globalFunctions);

    return (
        <div key={params.obra.cct} className="col-md-3 col-sm-3">
            <div className="card-container manual-flip">
                <div
                    className="card"
                    onClick={e => advancedClick(e, (e => params.onClick(params.obra)))}
                    onTouchStart={e => advancedClick(e, (e => params.onClick(params.obra)))}
                    onTouchEnd={e => advancedClick(e, (e => params.onClick(params.obra)))}
                    onMouseDown={e => advancedClick(e, (e => params.onClick(params.obra)))}
                    onMouseUp={e => advancedClick(e, (e => params.onClick(params.obra)))}
                >
                    <div className="front">
                        <div className="cover" style={{ background: '#78AB46' }}></div>
                        <div className="branded" style={{ color: '#4C4C4D' }}>
                            <span className='fa fa-cubes'></span>
                        </div>
                        <div className="content">
                            <div className="main">
                                <h4 className="use-for" style={{ color: '#4C4C4D', marginTop: '0px', fontSize: '13px' }}>{"[" + params.obra.cct.trim() + "] " + params.obra.descricao}</h4>
                            </div>
                        </div>
                    </div>

                    {/* Ele precisa desta secção pois o original permitia virar a card, como limpei o conteudo tenho que meter uma largura minima*/}
                    <div className="back">
                        <div className="header">
                        </div>
                        <div className="content">
                            <div style={{ minWidth: '190px', }}></div>
                        </div>
                        <div className="footer">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ObraCard